import { Button, Typography } from "@suraasa/placebo-ui"
import AsyncBuilder from "components/AsyncBuilder"
import { useEffect, useState } from "react"

import LimitReachedGradient from "../assets/limit-reached-gradient.webp"
import SingleAiSparkle from "../assets/SingleAiSparkle"
import SuraasaBigPlusIcon from "../assets/suraasa-big-plus-icon.svg"
import SuraasaPlusLogo from "../components/SuraasaPlusLogo"
import { useSuraasaPlusContext } from "../context"
import { getTimeUntilMidnightUTC } from "./helper"

const GenerationLimitReachedCard = () => {
  const {
    initiateSuraasaPlusPurchaseFlow,
    isFreeTrialAvailable,
    canGenerate,
    isActive,
  } = useSuraasaPlusContext()

  const [timeLeft, setTimeLeft] = useState(getTimeUntilMidnightUTC())

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeUntilMidnightUTC())
    }, 60 * 1000)
    return () => clearInterval(interval)
  }, [])

  if (!canGenerate && !isActive) {
    return (
      <div className="relative z-10 mx-2 mb-5 mt-2.25 overflow-hidden rounded-2xl bg-[linear-gradient(180deg,#0E1524_0%,#082743_64.06%)] p-3">
        <img
          className="absolute -bottom-3.5 -right-1 -z-10 h-20 w-[450px] object-contain sm:-bottom-0 sm:-right-1 sm:-z-10 sm:h-20 sm:w-[450px]"
          src={LimitReachedGradient}
          alt="limit-reached"
        />
        <img
          src={SuraasaBigPlusIcon}
          alt="suraasa-big-plus-icon"
          className="absolute -bottom-6 -right-6 -z-10 size-[180px] sm:-right-6 sm:-top-6 sm:-z-10 sm:size-[280px]"
        />
        <div className="flex flex-col items-start justify-between sm:flex-row sm:items-center">
          <div className="flex flex-col">
            <div className="flex flex-col items-start gap-0 sm:flex-row sm:items-center sm:gap-1">
              <div className="rounded-[7px] bg-[#524C37] p-[5px]">
                <SingleAiSparkle height={11} width={11} fill="#EEC239" />
              </div>
              <div className="mt-0.5 flex flex-col items-start sm:mt-0 sm:flex-row sm:items-center">
                <Typography className="text-warning-300" variant="strong">
                  Daily Limit Reached
                </Typography>
                <Typography
                  variant="smallBody"
                  className="hidden text-onSurface-400 sm:block"
                >
                  {" "}
                  ·{" "}
                </Typography>
                <Typography
                  variant="smallBody"
                  className="mt-0.25 text-onSurface-400 sm:mt-0"
                >
                  Limit resets in{" "}
                  <span className="text-strongSmallBody">{timeLeft}</span>{" "}
                </Typography>
              </div>
            </div>

            <div className="max-w-md">
              <div className="mb-1.5 mt-2 flex flex-wrap items-baseline gap-x-0.5 text-title3 text-onSurface-200">
                <span>Unlock Unlimited Access with</span>
                <div className="mt-1 md:mt-0">
                  <SuraasaPlusLogo height={24} width={127} />
                </div>
              </div>
              <Typography variant="smallBody" className="text-onSurface-400">
                Get hours of work done in minutes. Upgrade to Suraasa Plus for
                uninterrupted access to all AI tools.
              </Typography>
            </div>
          </div>
          <AsyncBuilder
            handler={async () => await initiateSuraasaPlusPurchaseFlow()}
            render={props => (
              <Button
                onClick={props.onClick}
                loading={props.loading}
                className="mt-4 shrink-0 bg-white p-1 text-onSurface-900 sm:mt-0"
              >
                {isFreeTrialAvailable ? "Try Suraasa Plus" : "Get Suraasa Plus"}
              </Button>
            )}
          />
        </div>
      </div>
    )
  }
}

export default GenerationLimitReachedCard
